<template>
  <v-autocomplete
    v-model="model_value_computed"
    v-bind="$attrs"
    item-value="id"
    item-text="descricao"
    :items="items"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        indeterminate
        :color="cor_loading"
      ></v-progress-linear>
    </template>
  </v-autocomplete>
</template>

<script setup>
import { computed, ref } from 'vue';

const props = defineProps({
  model_value: {
    type: [Object, String],
    default: () => ({})
  },
  cor_loading: {
    type: String,
    default: 'red'
  },
});

const emit = defineEmits(['update:model_value']);
const loading = ref(false);

const items = [
  {
    id: "CIF",
    descricao: "CIF"
  },
  {
    id: "FOB",
    descricao: "FOB"
  }
];

const model_value_computed = computed({
  get: () => props.model_value,
  set: valor => emit('update:model_value', valor)
});
</script>
